import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import ActionCenterMessageDetail from './ActionCenterMessageDetail';

loadDOMComponent({
	selector: 'react-action-message-detail',
	callback: ({ container, context }: any) => {
		const conversationId = container.getAttribute('conversationId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ActionCenterMessageDetail conversationId={conversationId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
